import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  className?: string;
  dataTestId?: string;
  type?: 'member' | 'new';
}

export default function Badge({ children, className = '', dataTestId, type = 'member' }: Props): JSX.Element {
  return (
    <span className={`hu-badge hu-badge-${type} ${className}`} data-testid={dataTestId}>
      {children}
    </span>
  );
}
